import { render, staticRenderFns } from "./PopoutWrapper.vue?vue&type=template&id=ba60e4ec&"
import script from "./PopoutWrapper.vue?vue&type=script&lang=js&"
export * from "./PopoutWrapper.vue?vue&type=script&lang=js&"
import style0 from "./PopoutWrapper.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports